import { __extends } from "tslib";
import React, { Component } from 'react';
import FormHeaderWrapper, { FormHeaderContent, FormHeaderDescription, FormHeaderTitle, } from './styled/FormHeader';
var FormHeader = /** @class */ (function (_super) {
    __extends(FormHeader, _super);
    function FormHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormHeader.prototype.render = function () {
        var _a = this.props, title = _a.title, description = _a.description, children = _a.children;
        return (React.createElement(FormHeaderWrapper, null,
            title && React.createElement(FormHeaderTitle, null, title),
            description && (React.createElement(FormHeaderDescription, null, description)),
            React.createElement(FormHeaderContent, null, children)));
    };
    return FormHeader;
}(Component));
export default FormHeader;
//# sourceMappingURL=FormHeader.js.map